import React from "react";

export const TwoTextCard = ({ title, subText, color }) => {
  return (
      <div className='mb-3'>
          <p className="fw-bold mb-1" style={{color: color}}>{title}</p>
          <p className='mb-0' style={{color: color === '#FFF' ? '#ccc' : color}}>{subText}</p>
      </div>
  )
}